import { useRef, useCallback } from 'react';

// Объявление типа WakeLockSentinel для Web Wake Lock API
interface WakeLockSentinel {
  readonly released: boolean;
  readonly type: 'screen';
  onrelease: ((this: WakeLockSentinel, ev: Event) => any) | null;
  addEventListener(type: 'release', listener: (this: WakeLockSentinel, ev: Event) => any): void;
  removeEventListener(type: 'release', listener: (this: WakeLockSentinel, ev: Event) => any): void;
  release(): Promise<void>;
}

/**
 * Хук для управления Wake Lock API (предотвращение засыпания устройства)
 */
export const useWakeLock = () => {
  const wakeLockRef = useRef<WakeLockSentinel | null>(null);

  const requestWakeLock = useCallback(async () => {
    const nav = navigator as any;
    if (!nav.wakeLock || wakeLockRef.current !== null) {
      return;
    }

    try {
      wakeLockRef.current = await nav.wakeLock.request('screen') as WakeLockSentinel;
      wakeLockRef.current.addEventListener('release', () => {
        wakeLockRef.current = null;
      });
    } catch (error) {
      console.warn('[WakeLock] Не поддерживается или недоступен:', error);
    }
  }, []);

  const releaseWakeLock = useCallback(async () => {
    if (wakeLockRef.current) {
      try {
        await wakeLockRef.current.release();
        wakeLockRef.current = null;
      } catch (error) {
        console.warn('[WakeLock] Ошибка освобождения:', error);
      }
    }
  }, []);

  // Очистка при размонтировании
  const cleanup = useCallback(() => {
    releaseWakeLock();
  }, [releaseWakeLock]);

  return {
    requestWakeLock,
    releaseWakeLock,
    cleanup,
  };
};
